import { object, string } from 'yup';
import { confirmPasswordSchema, passwordDetailedSchema } from '@/shared/lib/validation/password';
import { getAge } from '@/shared/lib/utils/getAge';

export const step2Schema = object({
  birthDate: string()
    .nullable()
    .notRequired()
    .matches(/^\d{2}\.\d{2}\.\d{4}$/, 'Неверный формат даты')
    .test(function (value) {
      if (!value) return true;
      const age = getAge(value);
      if (age < 0)
        return this.createError({
          message: `Неверный диапазон`,
          path: 'birthDate',
        });
      else if (age < 8)
        return this.createError({
          message: `Вам должно быть больше 8 лет`,
          path: 'birthDate',
        });
      else if (age > 99)
        return this.createError({
          message: `Неверный диапазон`,
          path: 'birthDate',
        });
      else return true;
    }),
  nickname: string()
    .required('Обязательное поле')
    .max(16, 'Максимальная длина 16 символов')
    .matches(/^[a-zA-Zа-яА-ЯёЁ0-9-]+$/, 'Может содержать только кириллические, латинские символы, цифры и символ тире'),
  vkLink: string()
    .nullable()
    .notRequired()
    .matches(/^[hH][tT][tT][pP][sS]:\/\/[vV][kK]\.(?:[rR][uU]|[cC][oO][mM])\/[a-zA-Zа-яА-ЯёЁ0-9_.-]*$/, {
      message: 'Ссылка должна содержать "https://vk.ru/username"',
      excludeEmptyString: true,
    }),
  password: passwordDetailedSchema().required('Обязательное поле'),
  confirmPassword: confirmPasswordSchema('password', 'Пароли не совпадают').required('Обязательное поле'),
});
